import { api } from "constants/RotasAPI";
import useDelete from "hooks/useDelete";
import toast from "react-hot-toast";
import { queryClient } from "shared/util/queryClient";

export const useDeleteDespesaGroupPay = () => {
  const onSuccess = () => {
    queryClient.invalidateQueries(["despesas-paginadas-group-pay"]);
    toast.success("Despesa excluída com sucesso!");
  };

  const onError = () => {
    toast.error("Erro ao excluir a despesa!");
  };

  return useDelete<number>({
    url: api.groupPay.deleteDespesaGroupPay,
    onSuccess,
    onError,
  });
};
